import { render } from "./ColorBadge.vue?vue&type=template&id=2df6ba5a&scoped=true"
import script from "./ColorBadge.vue?vue&type=script&lang=js"
export * from "./ColorBadge.vue?vue&type=script&lang=js"

import "./ColorBadge.vue?vue&type=style&index=0&id=2df6ba5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df6ba5a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QItemLabel});
